import React from 'react';
export function ClientLogosAngled() {
  // Replace these with your actual client logos
  const row1Logos = ['Howard Vineyard', 'Kennedy Smith', 'Peterson House', 'Olivers Taranga', 'Printhie', 'Rikard', 'The Lane'];
  const row2Logos = ['Vinesmith Group', 'Blue Pyrenees', 'Glenlofty', 'Nimble Vintner', 'Kaelser', 'Mr Mick', 'Tim Adams'];
  const row3Logos = ['Milton', 'Ross Hill', 'Fowles', 'Heartland', 'Talits', 'Paringa', 'Chateau Tanunda'];
  // Create quadrupled arrays for seamless looping
  const row1Repeated = [...row1Logos, ...row1Logos, ...row1Logos, ...row1Logos];
  const row2Repeated = [...row2Logos, ...row2Logos, ...row2Logos, ...row2Logos];
  const row3Repeated = [...row3Logos, ...row3Logos, ...row3Logos, ...row3Logos];
  return <>
      {/* Desktop Layout - Hidden on mobile/small screens */}
      <section className="relative h-screen hidden md:flex items-center py-12 bg-[#FAF7F2] overflow-hidden" data-id="element-32">
        {/* Title */}
        <div className="relative z-10 max-w-[800px] px-6 sm:px-12 md:px-16 lg:px-18" data-id="element-33">
          <h2 className="text-[#2C2416] text-[clamp(48px,6vw,72px)] font-light leading-[1.0] tracking-[-3px] font-['Inter'] whitespace-nowrap" data-id="element-34">
            Partners In Growth
          </h2>
        </div>
        {/* Angled Logo Container */}
        <div className="absolute overflow-hidden" style={{
        bottom: '-120px',
        right: '-200px',
        width: '80%',
        height: '75%',
        transform: 'rotate(-35deg)'
      }} data-id="element-35">
          {/* Gradient Fade Edges */}
          <div className="absolute top-0 bottom-0 left-0 pointer-events-none z-[2]" style={{
          width: '150px',
          background: 'linear-gradient(90deg, #FAF7F2 0%, transparent 100%)'
        }} data-id="element-36" />
          <div className="absolute top-0 bottom-0 right-0 pointer-events-none z-[2]" style={{
          width: '150px',
          background: 'linear-gradient(270deg, #FAF7F2 0%, transparent 100%)'
        }} data-id="element-37" />
          {/* Row 1 - Scrolls Left to Right */}
          <div className="flex items-center mb-12 group" style={{
          gap: '60px',
          padding: '20px 0'
        }} data-id="element-38">
            <div className="flex logo-track-left group-hover:paused" style={{
            gap: '60px',
            width: 'max-content'
          }} data-id="element-39">
              {row1Repeated.map((logo, idx) => <div key={`row1-${idx}`} className="flex-shrink-0 bg-white rounded transition-all duration-300" style={{
              padding: '24px 40px',
              border: '1px solid rgba(44, 36, 22, 0.08)',
              borderRadius: '4px',
              transform: 'skewX(10deg)',
              opacity: 0.7
            }} onMouseEnter={e => {
              e.currentTarget.style.opacity = '1';
              e.currentTarget.style.transform = 'skewX(10deg) translateY(-2px)';
              e.currentTarget.style.boxShadow = '0 4px 8px rgba(44, 36, 22, 0.1)';
              e.currentTarget.style.borderColor = 'rgba(212, 165, 116, 0.3)';
            }} onMouseLeave={e => {
              e.currentTarget.style.opacity = '0.7';
              e.currentTarget.style.transform = 'skewX(10deg)';
              e.currentTarget.style.boxShadow = 'none';
              e.currentTarget.style.borderColor = 'rgba(44, 36, 22, 0.08)';
            }} data-id="element-40">
                  <span className="text-[#8B7355] font-medium whitespace-nowrap" style={{
                fontSize: '20px'
              }} data-id="element-41">
                    {logo}
                  </span>
                </div>)}
            </div>
          </div>
          {/* Row 2 - Scrolls Right to Left */}
          <div className="flex items-center mb-12 group" style={{
          gap: '60px',
          padding: '20px 0'
        }} data-id="element-42">
            <div className="flex logo-track-right group-hover:paused" style={{
            gap: '60px',
            width: 'max-content'
          }} data-id="element-43">
              {row2Repeated.map((logo, idx) => <div key={`row2-${idx}`} className="flex-shrink-0 bg-white rounded transition-all duration-300" style={{
              padding: '24px 40px',
              border: '1px solid rgba(44, 36, 22, 0.08)',
              borderRadius: '4px',
              transform: 'skewX(10deg)',
              opacity: 0.7
            }} onMouseEnter={e => {
              e.currentTarget.style.opacity = '1';
              e.currentTarget.style.transform = 'skewX(10deg) translateY(-2px)';
              e.currentTarget.style.boxShadow = '0 4px 8px rgba(44, 36, 22, 0.1)';
              e.currentTarget.style.borderColor = 'rgba(212, 165, 116, 0.3)';
            }} onMouseLeave={e => {
              e.currentTarget.style.opacity = '0.7';
              e.currentTarget.style.transform = 'skewX(10deg)';
              e.currentTarget.style.boxShadow = 'none';
              e.currentTarget.style.borderColor = 'rgba(44, 36, 22, 0.08)';
            }} data-id="element-44">
                  <span className="text-[#8B7355] font-medium whitespace-nowrap" style={{
                fontSize: '20px'
              }} data-id="element-45">
                    {logo}
                  </span>
                </div>)}
            </div>
          </div>
          {/* Row 3 - Scrolls Left to Right */}
          <div className="flex items-center group" style={{
          gap: '60px',
          padding: '20px 0'
        }} data-id="element-46">
            <div className="flex logo-track-left group-hover:paused" style={{
            gap: '60px',
            width: 'max-content'
          }} data-id="element-47">
              {row3Repeated.map((logo, idx) => <div key={`row3-${idx}`} className="flex-shrink-0 bg-white rounded transition-all duration-300" style={{
              padding: '24px 40px',
              border: '1px solid rgba(44, 36, 22, 0.08)',
              borderRadius: '4px',
              transform: 'skewX(10deg)',
              opacity: 0.7
            }} onMouseEnter={e => {
              e.currentTarget.style.opacity = '1';
              e.currentTarget.style.transform = 'skewX(10deg) translateY(-2px)';
              e.currentTarget.style.boxShadow = '0 4px 8px rgba(44, 36, 22, 0.1)';
              e.currentTarget.style.borderColor = 'rgba(212, 165, 116, 0.3)';
            }} onMouseLeave={e => {
              e.currentTarget.style.opacity = '0.7';
              e.currentTarget.style.transform = 'skewX(10deg)';
              e.currentTarget.style.boxShadow = 'none';
              e.currentTarget.style.borderColor = 'rgba(44, 36, 22, 0.08)';
            }} data-id="element-48">
                  <span className="text-[#8B7355] font-medium whitespace-nowrap" style={{
                fontSize: '20px'
              }} data-id="element-49">
                    {logo}
                  </span>
                </div>)}
            </div>
          </div>
        </div>
      </section>
      {/* Mobile Layout - Only visible on mobile/small screens */}
      <section className="md:hidden py-16 bg-[#FAF7F2]" data-id="element-50">
        <div className="container mx-auto px-6" data-id="element-51">
          {/* Title - Centered on mobile */}
          <h2 className="text-[#2C2416] text-[clamp(40px,8vw,60px)] font-light leading-[1.1] tracking-[-3px] font-['Inter'] text-center mb-12" data-id="element-52">
            Partners In Growth
          </h2>
          {/* Mobile Logo Rows - Simple horizontal layout */}
          <div className="space-y-8" data-id="element-53">
            {/* Row 1 */}
            <div className="overflow-x-auto pb-4" data-id="element-54">
              <div className="flex logo-track-left-mobile whitespace-nowrap" style={{
              gap: '20px',
              width: 'max-content'
            }} data-id="element-55">
                {row1Repeated.map((logo, idx) => <div key={`mobile-row1-${idx}`} className="flex-shrink-0 bg-white rounded transition-all duration-300 py-3 px-6" style={{
                border: '1px solid rgba(44, 36, 22, 0.08)',
                opacity: 0.8
              }} data-id="element-56">
                    <span className="text-[#8B7355] font-medium whitespace-nowrap text-sm" data-id="element-57">
                      {logo}
                    </span>
                  </div>)}
              </div>
            </div>
            {/* Row 2 */}
            <div className="overflow-x-auto pb-4" data-id="element-58">
              <div className="flex logo-track-right-mobile whitespace-nowrap" style={{
              gap: '20px',
              width: 'max-content'
            }} data-id="element-59">
                {row2Repeated.map((logo, idx) => <div key={`mobile-row2-${idx}`} className="flex-shrink-0 bg-white rounded transition-all duration-300 py-3 px-6" style={{
                border: '1px solid rgba(44, 36, 22, 0.08)',
                opacity: 0.8
              }} data-id="element-60">
                    <span className="text-[#8B7355] font-medium whitespace-nowrap text-sm" data-id="element-61">
                      {logo}
                    </span>
                  </div>)}
              </div>
            </div>
            {/* Row 3 */}
            <div className="overflow-x-auto pb-4" data-id="element-62">
              <div className="flex logo-track-left-mobile whitespace-nowrap" style={{
              gap: '20px',
              width: 'max-content'
            }} data-id="element-63">
                {row3Repeated.map((logo, idx) => <div key={`mobile-row3-${idx}`} className="flex-shrink-0 bg-white rounded transition-all duration-300 py-3 px-6" style={{
                border: '1px solid rgba(44, 36, 22, 0.08)',
                opacity: 0.8
              }} data-id="element-64">
                    <span className="text-[#8B7355] font-medium whitespace-nowrap text-sm" data-id="element-65">
                      {logo}
                    </span>
                  </div>)}
              </div>
            </div>
          </div>
        </div>
      </section>
      <style jsx data-id="element-66">{`
        @keyframes scrollLeft {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-50%);
          }
        }
        @keyframes scrollRight {
          0% {
            transform: translateX(-50%);
          }
          100% {
            transform: translateX(0);
          }
        }
        .logo-track-left {
          animation: scrollLeft 60s linear infinite;
        }
        .logo-track-right {
          animation: scrollRight 60s linear infinite;
        }
        .paused {
          animation-play-state: paused !important;
        }
        /* Mobile animations - faster and simpler */
        @keyframes scrollLeftMobile {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-50%);
          }
        }
        @keyframes scrollRightMobile {
          0% {
            transform: translateX(-50%);
          }
          100% {
            transform: translateX(0);
          }
        }
        .logo-track-left-mobile {
          animation: scrollLeftMobile 40s linear infinite;
        }
        .logo-track-right-mobile {
          animation: scrollRightMobile 40s linear infinite;
        }
      `}</style>
    </>;
}